export default "__VITE_ASSET__fxSOK$ok__"